import { SendCodeTimer } from 'components/SendCodeTimer';
import { styled } from 'libs/ui/styled';

export const SendCodeTimerStyled = styled(SendCodeTimer)({
  marginLeft: 8,
  '.sendCodeTimer-button': {
    paddingRight: 0,
  },
});
